import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

type Props = {
  title: string;
  tabs: React.ReactNode;
  children: React.ReactNode;
  footer: React.ReactNode;
};

export const DecarbPageLayout: React.FC<Props> = ({
  title,
  tabs,
  footer,
  children,
}) => {
  return (
    <React.Fragment>
      <Box
        data-name='decarb-flow-layout'
        sx={{
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <Stack
          spacing={0}
          px={30}
          width={'100%'}
          pt={8}
        >
          {/** TITLE */}
          <Typography className={'main-header'} variant={'h4'}>
            {title}
          </Typography>

          {/** TABS */}
          <Box>{tabs}</Box>

          {/** MAIN CONTENT */}
          <Box>
            {children}
          </Box>
        </Stack>
      </Box>
      {/** FOOTER - rendered outside content box so position:sticky works at page level */}
      {footer}
    </React.Fragment>
  );
};
